import styled from "styled-components";

export const ArrowButton = styled.button`
  display: flex;
  height: 39px;
  padding: 6px 10px;
  justify-content: center;
  align-items: center;
  gap: 6px;

  background-color: var(--primary-dark-100);
  border: none;
  border-radius: 5px;
  cursor: pointer;
  color: var(--primary-blue);
  transition: background-color 0.3s ease-in-out;

  svg {
    transition: transform 0.3s ease-in-out;
    transform: translateY(0);
  }

  &:hover {
    background-color: var(--primary-blue-200);
    svg {
      transform: translateY(-1px);
    }
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`;

export const ArrowGroup = styled.div`
  display: flex;
  gap: 8px;
`;
